(function () {

    const navButtons = document.querySelectorAll('.faq__nav .so-cta');

    const faqCategories = document.querySelectorAll('.block__faq-category');

    navButtons.forEach(button => {
        button.addEventListener('click', () => {
            navButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            const targetCategory = button.getAttribute('data-cat');

            if(targetCategory === 'faqs-all'){
                faqCategories.forEach(category => {
                    category.style.display = 'block';
                });
                return; // Exit the function early since we want to show all categories 
            }

            faqCategories.forEach(category => {
                if (category.id === targetCategory) {
                    category.style.display = 'block';
                } else {
                    category.style.display = 'none';
                }
            });
        });
    });

})();